import { Moment } from 'moment'
import { DateOperator } from '@global/constants'
import { UnreachableError } from '@global/utils'
import { DB_FORMAT, DISPLAY_FORMAT } from './config'

export function getDateString(operator: DateOperator, date: Moment): string {
  const unit = 'day'

  switch (operator) {
    case DateOperator.GREATER_THAN: {
      return date.startOf(unit).format(DB_FORMAT)
    }
    case DateOperator.LESS_THAN: {
      return date.endOf(unit).format(DB_FORMAT)
    }
    case DateOperator.CONTAINS:
    case DateOperator.NOT_CONTAINS:
    case DateOperator.EMPTY:
    case DateOperator.NOT_EMPTY: {
      return date.format(DISPLAY_FORMAT)
    }
  }

  throw new UnreachableError(operator, `Unexpected operator type: ${operator}`)
}
